import { getProjectFlavourLabel, getTaskFlavourLabel } from '~/utils/project_flavour';
import { get } from 'lodash-es';
import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapGetters(['tasks', 'projects']),
    ...mapState(['organization']),
    noTaskText() {
      const taskLabel = getTaskFlavourLabel(this.organization.project_flavour);

      return `No ${taskLabel.toLowerCase()}`;
    },
    noProjectText() {
      const projectLabel = getProjectFlavourLabel(this.organization.project_flavour);

      return `No ${projectLabel.toLowerCase()}`;
    },
  },
  methods: {
    workingProjectForUser(user) {
      if (!user.lastActivity) {
        return this.noProjectText;
      }

      const projectId = get(user, 'lastActivity.project_id');
      const project = this.projects.find((project) => project.id === projectId);

      return !project ? this.noProjectText : project.name;
    },
    workingTaskForUser(user) {
      if (!user.lastActivity) {
        return this.noTaskText;
      }

      const taskId = get(user, 'lastActivity.task_id');
      const task = this.tasks.find((task) => task.id === taskId);

      return !task ? this.noTaskText : task.summary || task.name;
    },
  },
};
